import { useTranslation } from 'react-i18next'

import { CopyIcon, DotsThreeCircleVerticalIcon, EyeIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ActionsMenu = ({ criterion, isEditable, onEdit, onDuplicate, onDelete }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <ButtonMenu
        stopPropagation
        menuItems={[
          {
            label: (
              <Styles.MenuItem>
                {isEditable ? <PencilSimpleIcon /> : <EyeIcon />} {isEditable ? t('Editar') : t('Ver')}
              </Styles.MenuItem>
            ),
            onClick: () => onEdit(criterion),
          },
          ...(isEditable
            ? [
                {
                  label: (
                    <Styles.MenuItem>
                      <CopyIcon /> {t('Duplicar')}
                    </Styles.MenuItem>
                  ),
                  onClick: () => onDuplicate(criterion),
                },
                {
                  label: (
                    <Styles.MenuItem>
                      <TrashIcon /> {t('Eliminar')}
                    </Styles.MenuItem>
                  ),
                  onClick: () => onDelete(criterion),
                  disabled: criterion.is_used,
                },
              ]
            : []),
        ]}
        renderButton={onClick => (
          <IconButton
            variant="text"
            onClick={onClick}
            icon={<DotsThreeCircleVerticalIcon size={24} weight="light" />}
          />
        )}
      />
    </Styles.Container>
  )
}

export default ActionsMenu
